<template>
  <div class="loader" :class="size">
    <div class="bounce1" />
    <div class="bounce2" />
    <div class="bounce3" />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'normal',
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.loader {
  width: 70px;
  display: inline-block;
}

.bounce1,
.bounce2,
.bounce3 {
  width: 10px;
  height: 10px;
  background-color: $primary-color;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

.big {
  .bounce1,
  .bounce2,
  .bounce3 {
    width: 30px;
    height: 30px;
    margin-right: 20px;
  }
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@media only screen and (max-width: 1200px) {
  .header-nav-right-container {
    width: 680px;
  }
}
</style>
